// hooks/billing/usePricingCatalog.js
import { useCallback, useEffect, useState } from 'react';
import BillingService from '../../services/billing.service';

/**
 * usePricingCatalog — public pricing catalog (`GET /pricing/catalog`).
 *
 * Returns:
 *   - resources:       { [resource]: { coins, unit, note? } }
 *   - assistantTiers:  [{ tier, coins, label, models: string[] }]
 *   - imageModels:     [{ modelKey, displayName, coinsPerImage, supports }]
 *   - comingSoon:      [{ feature, displayName, description }]
 *
 * No auth required; we still call it from authenticated views via the
 * shared billing client. Stable across user context.
 */
export function usePricingCatalog({ auto = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(auto);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    const result = await BillingService.getPricingCatalog();
    if (result.success) {
      setData(result.data ?? null);
    } else {
      setError(result);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (auto) refetch();
  }, [auto, refetch]);

  return { data, loading, error, refetch };
}

export default usePricingCatalog;
